import React from "react";
import { Modal, DatePicker, message } from "antd";
import API_URL from "../../../../common/url";
import ExportUtil from "../../../../common/ExportUtil";
import moment from "moment";
import Fetch from "../../../../common/Fetch";

const { MonthPicker } = DatePicker;
const DefaultDate = moment().format('YYYY-MM');
const DefaultState = {
    range: 'total',
    date: DefaultDate,
    investigationId: undefined,
};

class ExportFixedLine extends React.Component {
    state = {
        visible: false,
        loading: false,
        ...DefaultState,
    }

    show = (url) => {
        this.setState({
            visible: true,
            url,
            ...DefaultState,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { date, range, investigationId, url } = this.state;
        if (!date) {
            message.warning('请先选择固化月份');
            return;
        }
        this.setState({ loading: true });
        Fetch.post(url, {
            investigationId,
            date,
        }).then((res) => {
            this.setState({ loading: false }, () => {
                message.success(res.success);
                this.hide();
                //this.export();
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    export = () => {
        const { date, investigationId } = this.state;
        const url = API_URL.investigation.downloadUserFte;
        ExportUtil.export({ date, investigationId }, null, url);
        this.hide();
    }

    handleChange = (value, key) => {
        const extra = {};
        if (key === 'range') {
            if (value === 'detail') {
                extra.investigationId = -4;
            } else {
                extra.investigationId = undefined;
            }
        }
        this.setState({
            [key]: value,
            ...extra,
        });
    }

    disabledDate = (current) => {
        return current && current.valueOf() > moment().valueOf();
    }

    render() {
        const { visible, loading, date } = this.state;
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                width="460px"
                loading={loading}
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">请先选择固化月份</div>
                            <div className="item-right">
                                <MonthPicker
                                    allowClear={false}
                                    placeholder="选择月份"
                                    style={{ width: 160 }}
                                    value={date ? moment(date) : null}
                                    disabledDate={this.disabledDate}
                                    onChange={(date, dateString) => this.handleChange(dateString, 'date')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default ExportFixedLine;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/ExportFixedLine.js